module.exports = __webpack_public_path__ + "static/media/sf_1000_gray.00ad35c532c4052c0160d434808c612f.png";